import { TableCell, TableCellProps } from "@mui/material";
import { forwardRef } from "react";

export type SHTableCellProps = TableCellProps;
export const SHTableCell = forwardRef(
  (props: SHTableCellProps, ref: any): JSX.Element => (
    <TableCell {...props} ref={ref} />
  ),
);
